import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptorkwnwsc78b2on as PrimitiveSerialDescriptor } from './Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Instant2s2zyzgfc4947 as Instant,
  Companion_getInstance138pnyl3l6agm as Companion_getInstance_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import {
  Duration__toIsoString_impl_9h6wsm1isvj2n1k1yz8 as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { NothingSerialDescriptor_getInstance1ca2kodn2hhci as NothingSerialDescriptor_getInstance } from './NothingSerialDescriptor.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UuidSerializerClass;
function UuidSerializer() {
  if (UuidSerializerClass === VOID) {
    class $ {
      constructor() {
        UuidSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.uuid.Uuid', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_afc75_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_afc75_k$(encoder, value instanceof Uuid() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_getInstance().parse_pc1q8p_k$(decoder.decodeString_x3hxsx_k$());
      }
    }
    initMetadataForObject($, 'UuidSerializer', VOID, VOID, [KSerializer()]);
    UuidSerializerClass = $;
  }
  return UuidSerializerClass;
}
var UuidSerializer_instance;
function UuidSerializer_getInstance() {
  if (UuidSerializer_instance === VOID)
    new (UuidSerializer())();
  return UuidSerializer_instance;
}
var InstantSerializerClass;
function InstantSerializer() {
  if (InstantSerializerClass === VOID) {
    class $ {
      constructor() {
        InstantSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.time.Instant', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_jk28sp_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_jk28sp_k$(encoder, value instanceof Instant() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_getInstance_0().parse_xovy9i_k$(decoder.decodeString_x3hxsx_k$());
      }
    }
    initMetadataForObject($, 'InstantSerializer', VOID, VOID, [KSerializer()]);
    InstantSerializerClass = $;
  }
  return InstantSerializerClass;
}
var InstantSerializer_instance;
function InstantSerializer_getInstance() {
  if (InstantSerializer_instance === VOID)
    new (InstantSerializer())();
  return InstantSerializer_instance;
}
var DurationSerializerClass;
function DurationSerializer() {
  if (DurationSerializerClass === VOID) {
    class $ {
      constructor() {
        DurationSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.time.Duration', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_fhst7c_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(Duration__toIsoString_impl_9h6wsm(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_fhst7c_k$(encoder, value instanceof Duration() ? value.rawValue_1 : THROW_CCE());
      }
      deserialize_gg0puu_k$(decoder) {
        return Companion_getInstance_1().parseIsoString_2c2d83_k$(decoder.decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Duration())(this.deserialize_gg0puu_k$(decoder));
      }
    }
    initMetadataForObject($, 'DurationSerializer', VOID, VOID, [KSerializer()]);
    DurationSerializerClass = $;
  }
  return DurationSerializerClass;
}
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance === VOID)
    new (DurationSerializer())();
  return DurationSerializer_instance;
}
var NothingSerializerClass;
function NothingSerializer() {
  if (NothingSerializerClass === VOID) {
    class $ {
      constructor() {
        NothingSerializer_instance = this;
        this.descriptor_1 = NothingSerialDescriptor_getInstance();
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_17ojz2_k$(encoder, value) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("'kotlin.Nothing' cannot be serialized");
      }
      serialize_5ase3y_k$(encoder, value) {
        var tmp;
        if (false) {
          tmp = value;
        } else {
          tmp = THROW_CCE();
        }
        return this.serialize_17ojz2_k$(encoder, tmp);
      }
      deserialize_sy6x50_k$(decoder) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("'kotlin.Nothing' does not have instances");
      }
    }
    initMetadataForObject($, 'NothingSerializer', VOID, VOID, [KSerializer()]);
    NothingSerializerClass = $;
  }
  return NothingSerializerClass;
}
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance === VOID)
    new (NothingSerializer())();
  return NothingSerializer_instance;
}
//region block: exports
export {
  DurationSerializer_getInstance as DurationSerializer_getInstance24c8qta2pbnpd,
  InstantSerializer_getInstance as InstantSerializer_getInstance1n2pd669tdsta,
  NothingSerializer_getInstance as NothingSerializer_getInstance2vzs25ljhki6v,
  UuidSerializer_getInstance as UuidSerializer_getInstance1ib26ji9vwcd4,
};
//endregion

//# sourceMappingURL=BuiltInSerializers.mjs.map
